module.exports = __webpack_public_path__ + "static/media/approveHover.0e7571f6.svg";